const actions = {
  PURCHASE_INVENTORY: "PURCHASE_INVENTORY",
  PURCHASE_INVENTORY_SUCCESS: "PURCHASE_INVENTORY_SUCCESS",
  PURCHASE_INVENTORY_FAILED: "PURCHASE_INVENTORY_FAILED",

  RESET_MESSAGE: 'RESET_MESSAGE',

  GET_PURCHASE_SIM_LIST: "GET_PURCHASE_SIM_LIST",
  GET_PURCHASE_SIM_LIST_SUCCESS: "GET_PURCHASE_SIM_LIST_SUCCESS",
  GET_PURCHASE_SIM_LIST_FAILED: "GET_PURCHASE_SIM_LIST_FAILED",

  GET_SIM_LIST: "GET_SIM_LIST",
  GET_SIM_LIST_SUCCESS: "GET_SIM_LIST_SUCCESS",
  GET_SIM_LIST_FAILED: "GET_SIM_LIST_FAILED",


  purchaseInventory: (data) => ({
    type: actions.PURCHASE_INVENTORY,
    payload: { data },
  }),
  purchaseInventorySuccess: (message) => ({
    type: actions.PURCHASE_INVENTORY_SUCCESS,
    message
  }),
  purchaseInventoryError: (error, fResult) => ({
    type: actions.PURCHASE_INVENTORY_FAILED,
    payload: { error, fResult },
  }),

  resetMessage: () => ({
    type: actions.RESET_MESSAGE,
  }),

    getSimList: (data) => ({
    type: actions.GET_SIM_LIST,
    payload: { data },
  }),
  getSimListSuccess: (result) => ({
    type: actions.GET_SIM_LIST_SUCCESS,
    result
  }),
  getSimListError: (error) => ({
    type: actions.GET_SIM_LIST_FAILED,
    error
  }),


  getPurchaseSimList: (data) => ({
    type: actions.GET_PURCHASE_SIM_LIST,
    payload: { data },
  }),
  getPurchaseSimListSuccess: (result) => ({
    type: actions.GET_PURCHASE_SIM_LIST_SUCCESS,
    result
  }),
  getPurchaseSimListError: (error) => ({
    type: actions.GET_PURCHASE_SIM_LIST_FAILED,
    error
  }),
};
export default actions;
